<template>
  <div class="item-container">
    <div>
      <h2 class="item__title">修正春季广告</h2>
      <div class="item__time">2019.01.01-12:30:30 至 2019.06.01-12:30:30</div>
    </div>
    <div class="item__bottom">
      <div>
        广告币(个)：
        <span>+360.00</span>
      </div>
      <div>播放30天</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {},

  async created() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.item-container {
  position: relative;
  padding: 10px 15px;
  height: 99px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  overflow: hidden;
  box-sizing: border-box;

  h2.item__title {
    margin: 0;
    padding: 0;
    height: 22px;
    font-size: 16px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
  }

  .item__time {
    margin: 4px 0 7px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
  }

  .item__bottom {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 6px;
    // width: 80px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 20px;
    // border-top: 1px solid #e1e1e1;
    border: none;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      border-top: 1px solid #e1e1e1;
      box-sizing: border-box;
      width: 200%;
      height: 200%;
      transform: scale(0.5);
      transform-origin: left top;
    }

    span {
      font-weight: 500;
      color: rgba(0, 122, 255, 1);
    }
  }
}
</style>
